import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate } from "../Helpers";
import { STR_BUY_NOW, STR_PAYMENT_STATUS, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_REGISTRATION_STATUS, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		appContext.navTo({
			item: "side-view",
			subItem: "sender-id-request-options",
			extraItem: data.id,
		});
	}

	return (
		<div
			className=""
			onClick={view}
			style={{
				padding: "10px",
				paddingTop: "20px",
				paddingBottom: "20px",
				borderBottom: "1px solid var(--secondaryColor)",
			}}
		>
			<h6
				style={{
					fontSize: "20px",
				}}
				className="font-semi-bold"
			>
				{data.senderId}
			</h6>

			<h6
				style={{
					fontSize: "12px",
				}}
				className="font-regular mt-4"
			>
				{STR_PAYMENT_STATUS[appContext.language]}: : <span className="font-semi-bold">{data.paymentStatus}</span>
			</h6>
			<h6
				style={{
					fontSize: "12px",
				}}
				className="font-regular mb-4"
			>
				{STR_REGISTRATION_STATUS[appContext.language]}: <span className="font-semi-bold">{data.registrationStatus}</span>
			</h6>

			<h6
				style={{
					fontSize: "12px",
				}}
				className="font-light text-end"
			>
				{formatDate(data.dateRequested)}
			</h6>
		</div>
	);
}
